import { z } from 'zod';

export enum SlackChannel {
    NEW_USER = 'newUser',
    OEM = 'oem',
    ALERT = 'alert',
    DEV = 'dev',
    SUPPORT_REQUEST = 'supportRequest',
    PAYMENT = 'payment',
    TRACKING = 'tracking',
    LOGGING = 'logging',
}

export const SlackChannelSchema = z.nativeEnum(SlackChannel);

export const SlackNotificationSchema = z.object({
    message: z.string(),
    channel: SlackChannelSchema.optional(),
});

export type SlackNotification = z.infer<typeof SlackNotificationSchema>;
